import { Text } from 'blaze-ui/Text/Text'
import Styles from './TopBar.module.scss'
import { ChevronRightSmall } from 'blaze-ui/icons'
import { useOnboardingStrategiesEnabled } from 'flows/virtualMarketerOnboarding/steps'
import cx from 'classnames'

interface Props {
  highlightStep: 'yourBusiness' | 'goalsAndPlan' | 'yourBrand' | 'generateContent'
  leftSide?: boolean
  withScoreCard?: boolean
}

export const TopBar = ({ highlightStep, leftSide = false, withScoreCard = false }: Props) => {
  const isOnboardingStrategiesEnabled = useOnboardingStrategiesEnabled()

  if (!isOnboardingStrategiesEnabled) return null

  return (
    <div className={cx(Styles.container, { [Styles.leftSide]: leftSide, [Styles.withScoreCard]: withScoreCard })}>
      <Text variant="placeholder" color={highlightStep === 'yourBusiness' ? 'var(--dark-90)' : 'var(--dark-40)'}>
        Your Business
      </Text>
      <ChevronRightSmall size={12} color="var(--dark-40)" />
      <Text variant="placeholder" color={highlightStep === 'goalsAndPlan' ? 'var(--dark-90)' : 'var(--dark-40)'}>
        Goals & Plan
      </Text>
      <ChevronRightSmall size={12} color="var(--dark-40)" />
      <Text variant="placeholder" color={highlightStep === 'yourBrand' ? 'var(--dark-90)' : 'var(--dark-40)'}>
        Your Brand
      </Text>
      <ChevronRightSmall size={12} color="var(--dark-40)" />
      <Text variant="placeholder" color={highlightStep === 'generateContent' ? 'var(--dark-90)' : 'var(--dark-40)'}>
        Generate Content
      </Text>
    </div>
  )
}
